module.exports = __webpack_public_path__ + "static/media/img_mobile2.11bbd8b3.png";